import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-welcome-six',
  templateUrl: './welcome-six.component.html',
  styleUrls: ['./welcome-six.component.css']
})
export class WelcomeSixComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
